import Vue from 'vue'
import App from './App.vue'
import router from './router'
import '@/assets/css/iconfont.css'
import $ from 'jquery'
Vue.config.productionTip = false

router.afterEach( () => {
  $('#app').scrollTop(0)
})
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
